import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Helmet from 'react-helmet';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Table from 'react-bootstrap/lib/Table';
import Button from 'react-bootstrap/lib/Button';
import { getAllUsers, getUser } from '../redux/modules/user';
import { deleteAccountForUser } from '../redux/modules/account';
import { ConfirmDeleteSavedAccount } from '../components/ConfirmationModals';

function AccountsTable({ accounts, onRemoveAccount }) {
  return (
    <Table>
      {_.map(accounts, ({ bankName, sageApiToken }) => (
        <tr key={bankName}>
          <td>{bankName}</td>
          <td>{sageApiToken}</td>
          <td>
            <ConfirmDeleteSavedAccount
              bankAccount={bankName}
              onConfirm={_.partial(onRemoveAccount, bankName)}
            >
              <i className="glyphicon glyphicon-remove pointer red"></i>
            </ConfirmDeleteSavedAccount>
          </td>
        </tr>
      ))}
    </Table>
  );
}

AccountsTable.propTypes = {
  accounts: PropTypes.array,
  onRemoveAccount: PropTypes.func.isRequired,
};

AccountsTable.defaultProps = {
  accounts: [],
};

export class UserAdmin extends Component {
  static propTypes = {
    users: PropTypes.array,
    getAllUsers: PropTypes.func.isRequired,
    getUser: PropTypes.func.isRequired,
    deleteAccountForUser: PropTypes.func.isRequired,
  };

  static defaultProps = {
    users: [],
  };

  componentWillMount() {
    const { getAllUsers } = this.props;
    getAllUsers();
  }

  handleDownload = ({ _id }) => this.props.getUser(_id);

  handleDeleteAccount = async (bankName, _id) => {
    const { deleteAccountForUser, getAllUsers } = this.props;
    await deleteAccountForUser(bankName, _id);
    return getAllUsers();
  };

  render() {
    const { users } = this.props;

    return (
      <div>
        <Helmet title="User Administration" />

        <Grid>
          <Row>
            <Col xs={12}>
              <Table responsive striped>
                <tr>
                  <th>Dealer ID</th>
                  <th>Email</th>
                  <th>Accounts</th>
                  <th>Created</th>
                </tr>
                <tbody>
                  {_.map(users, (user, idx) => {
                    const created = moment(user.created).format('MMM Do YYYY, h:mm:ss a');
                    // TODO search related todos by keyword: DealerIdDisplayProblem
                    // dealerId of users now stored on Auth0 DB.
                    // This table shows data from app's DB, so 'dealerInfo.dealerId' sill be empty.
                    // Question, should we store dealerId somehow to show it here?
                    return (
                      <tr key={idx}>
                        <td>{_.get(user, 'dealerInfo.dealerId')}</td>
                        <td>{user.email}</td>
                        <td>
                          <AccountsTable
                            accounts={user.savedAccounts}
                            onRemoveAccount={(bankName) =>
                              this.handleDeleteAccount(bankName, user._id)
                            }
                          />
                        </td>
                        <td>{created}</td>
                        <td>
                          <Button bsStyle="default" onClick={_.partial(this.handleDownload, user)}>
                            Download
                          </Button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    users: state.user.list,
  }),
  {
    getAllUsers,
    getUser,
    deleteAccountForUser,
  },
)(UserAdmin);
